module.exports = __webpack_public_path__ + "static/hero-bg-760890e2fb461f5721423b40aad4d41a.jpg";